var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylistsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1408_2577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 14.1348H2.33333C1.04222 14.1348 0 13.1026 0 11.8239V2.31087C0 1.03219 1.04222 0 2.33333 0H25.6667C26.9578 0 28 1.03219 28 2.31087V11.8239C28 13.1026 26.9578 14.1348 25.6667 14.1348ZM25.6667 23.3783H2.33333C1.04222 23.3783 0 24.4105 0 25.6891C0 26.9678 1.04222 28 2.33333 28H25.6667C26.9578 28 28 26.9678 28 25.6891C28 24.4105 26.9578 23.3783 25.6667 23.3783ZM25.6667 16.4457H2.33333C1.04222 16.4457 0 17.4779 0 18.7565C0 20.0352 1.04222 21.0674 2.33333 21.0674H25.6667C26.9578 21.0674 28 20.0352 28 18.7565C28 17.4779 26.9578 16.4457 25.6667 16.4457Z",
    fill: "#037A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1408_2577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistsActive);
export default __webpack_public_path__ + "static/media/Playlists_active.df65682766c7f726de44bd62cab2bd87.svg";
export { ForwardRef as ReactComponent };